import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export const CustomEventTriggerFullDetails = ({ trigger }: Props) => {
  const executedWhenLabel = useMemo(() => {
    const eventName = trigger.signature.split('(')[0];
    return (
      <div className="tw:flex tw:flex-row tw:gap-1">
        <Badge size="sm">{eventName}</Badge>
        <Text as="span" variant="body-sm">
          is sent via API or csv
        </Text>
      </div>
    );
  }, [trigger.signature]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed when" value={executedWhenLabel} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
};
